var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useEffect, useRef } from 'react';
const usePreviousPage = (previousPage) => {
    _react_refresh_temp_1();
    const ref = useRef();
    useEffect(() => {
        ref.current = previousPage;
    });
    return ref.current;
};
_react_refresh_temp_1(usePreviousPage, "8uVE59eA/r6b92xF80p7sH8rXLk=");
export default usePreviousPage;
